import theme from '@/common/styles/mui-theme';

const loginStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    m: 'auto',
    width: '100%',
    height: '100%',
  },
  formWrapper: {
    margin: 'auto',
    width: '100%',
    px: theme.spacing(5),
    [theme.breakpoints.up('tablet')]: {
      maxWidth: '440px',
      px: 0,
      py: theme.spacing(20),
    },
  },
  titleWrap: {
    marginBottom: theme.spacing(10),
  },
  subTitle: {
    color: theme.palette.text.secondary,
    ...theme.typography.body1,
    marginTop: theme.spacing(4),
  },
  formWrap: {
    width: '100%',
  },
  statusMessage: {
    marginBottom: theme.spacing(6),
  },
  readyPage: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minHeight: '100%',
  },
  readyHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    py: theme.spacing(5),
    px: theme.spacing(6),
  },
  readyLogo: {
    width: '173px',
    height: '38px',
    display: 'block',
    flexShrink: 0,
  },
  readyContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    px: theme.spacing(6),
  },
  readyIconWrap: {
    width: 80,
    height: 80,
    borderRadius: '16px',
    border: '1px solid #CFEBDD',
    backgroundColor: '#EEF7F2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    mb: theme.spacing(6),
  },
  expiredIconWrap: {
    width: 80,
    height: 80,
    borderRadius: '16px',
    border: '1px solid #CFEBDD',
    borderColor: `${theme.palette.system.red}30`,
    backgroundColor: `${theme.palette.system.red}30`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    mb: theme.spacing(6),
  },
  readyIcon: {
    fontSize: 36,
    color: '#2A7559',
  },
  readyDescription: {
    maxWidth: 500,
    mt: theme.spacing(8),
    whiteSpace: 'pre-line',
  },
  readyButton: {
    mt: theme.spacing(8),
  },
};

export default loginStyles;
